import React, { FC } from 'react';

// components
import { Descendant } from 'slate';

import styled from 'styled-components';

// model
import { MaxCharacterModel } from '../../../models/formula.model';

import FormulaAlternateMain from '../../../views/formulaCreate/formulaAlternate/FormulaAlternateMain';

interface AlternateListPreviewProps {
    formulaStructure: Descendant[];
    extraPlaceholderCharacters: MaxCharacterModel;
    formulaId: number;
    isEditable: boolean;
}

const AlternateListPreview: FC<
    React.PropsWithChildren<AlternateListPreviewProps>
> = ({ formulaStructure, formulaId, isEditable }) => {
    return (
        <Container>
            <FormulaAlternateMain
                formulaId={formulaId}
                isEditable={isEditable}
                formulaStructure={formulaStructure}
            />
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    width: '100%',
    overflow: 'auto',
});

export default AlternateListPreview;
